import React from 'react';
import DefaultLayout from '../layouts/default';
import JoinGroup from '../components/joinGroup-modal/joinGroup';

export default function JoinGroupPage() {


    return (
        <DefaultLayout> 
            <JoinGroup/>
        </DefaultLayout>
    );
}
